<template>
  <!--意见反馈页面-->
  <tk-container
    :status="status"
    native-scroll
  >
    <!--头部-->
    <my-header slot="header" :border-show="true">意见建议</my-header>
    <!--问题类型-->
    <card :width="100" :height="100">
      <card-title :title="'问题类型'" :is-more="false"></card-title>
      <tk-flex class="m-t-5 m-b-15" wrap gutter="15">
        <tk-flex
          center
          middle
          class="tk-grid-3 type-select"
          @click.native="selectType(index)"
          :class="{'type-selected': s.selected === true}"
          v-for="(s, index) in typeList"
          :key="index"
        >
          {{s.name}}
        </tk-flex>
      </tk-flex>
    </card>
    <card :width="100" :height="500" class="m-t-10 p-0">
      <card-title :title="'意见描述'" class="p-x-12 p-t-12" :is-more="false"></card-title>
      <!--意见描述-->
      <div class="p-x-12">
        <textarea name="hehe"
                  id="text-input"
                  cols="80" rows="9"
                  v-model="opinion"
                  class="text-input"
                  placeholder="感谢您的反馈，您的反馈将有助于我们做的更好。"
        ></textarea>
      </div>
      <!--反馈图片-->
      <three-image-post class="m-t-10" @postImage="receiveParams"></three-image-post>
      <!--提交按钮-->
      <div class="feed-back-btn">
        <tkui-button class="primary rounded block raised" :disabled="clickDisabled" @click.native="submitOpinion">提交</tkui-button>
      </div>
    </card>
  </tk-container>
</template>

<script>
import cardTitle from '@/components/cardTitle'
import threeImagePost from '@/components/threeImagePost'
export default {
  components: {
    cardTitle,
    threeImagePost
  },
  data () {
    return {
      status: false, // 页面状态
      typeIndex: 0, // 选定后的索引
      typeList: [ // 问题类型数据
        {
          selected: true,
          name: '产品',
          value: 'product'
        },
        {
          selected: false,
          name: '服务',
          value: 'service'
        },
        {
          selected: false,
          name: '人员',
          value: 'personnel'
        },
        {
          selected: false,
          name: '物流',
          value: 'logistics'
        },
        {
          selected: false,
          name: '宣传',
          value: 'propaganda'
        },
        {
          selected: false,
          name: '其他',
          value: 'orther'
        }
      ],
      environmentWaiting: false, // 上传图片等待状态
      clickDisabled: false, // 提交反馈按钮状态
      opinion: '', // 反馈内容
      pictureCombination: [] // 反馈图片
    }
  },
  activated () {
    this.setStatusBar('dark')
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  methods: {
    /**
    * 切换问题类别
    * @date: 2020/4/14
    */
    selectType (index) {
      this.typeList[index].selected = true
      this.typeList.forEach((s, inX) => { if (index !== inX) { s.selected = false } })
      this.typeIndex = index
    },
    /**
     * @Description: 接收图片数组
     * @author xiaozan
     * @date 2020/5/3
     */
    receiveParams (arr) {
      this.pictureCombination = arr
    },
    /**
     * 删除帖子图片
     * @date: 2020/3/26
     */
    deleteImage (index) {
      this.pictureCombination.splice(index, 1)
    },
    /**
    * 提交意见
    * @date: 2020/4/14
    */
    async submitOpinion () {
      if (!this.opinion) { return this.$tkGlobal.toast.add('意见描述不能为空') }
      this.status = 'waiting'
      this.clickDisabled = true
      let obj = {
        opinion: this.opinion,
        user: this.userInfo.objectId,
        questionType: this.typeList[this.typeIndex].value,
        pictureCombination: this.pictureCombination,
        status: 'untreated'
      }
      await this.$tkParse.post('/classes/feedBack', obj).catch(e => {
        this.clickDisabled = false
        this.status = false
        this.$tkGlobal.toast.add('网络错误')
        throw e
      })
      this.$back()
      this.$tkGlobal.toast.add('感谢您的反馈')
      this.status = false
    }
  }
}
</script>

<style scoped lang="scss">
/*类型选择样式*/
.type-select {
  width: 79px;
  height: 28px;
  border: 1px solid rgba(200, 200, 200, 1);
  border-radius: 3px;
  font-size: 14px;
  color: rgba(153, 153, 153, 1);
}
.type-selected {
  border: 1px solid rgba(253, 54, 54, 1);
  color: rgba(214, 30, 22, 1);
}
/*意见反馈样式*/
.text-input {
  height: 100%;
  width: 100%;
  min-width: 0;
  overflow-y: auto;
  resize: none;
}
.text-input::placeholder {
  font-size: 14px;
  color: rgba(157, 157, 157, 1);
}
/*图片样式*/
.posts-basic-bg-box{
  .posts-basic-bg-box-middle {
    width: 80px;
    height: 80px;
    position: relative;
  }
  .posts-basic-bg-box-image {
    width: 80px !important;
    height: 80px !important;
    .posts-basic-bg-box-image-icon {
      width: 100%;
      background: rgba(255, 255, 255, 0.3);
      position: absolute;
      line-height: 80px;
      left: 0;
      top: 0;
    }
  }
}
  /*按钮样式*/
.feed-back-btn {
  margin-top: 50px;
}
</style>
